// ==========================================================================
// CACTUS KNIGHT — Automatische Spracherkennung (Coming-Soon-Seite)
// Beim ersten Besuch: liest die Gerätesprache des Browsers aus und leitet
// EINMALIG zur passenden verfügbaren Sprachversion weiter. Sobald jemand
// manuell eine Sprache über den Umschalter wählt (oder die automatische
// Weiterleitung schon einmal stattgefunden hat), merkt sich das Gerät das
// dauerhaft (localStorage) — keine erneute automatische Umleitung danach.
// Nutzt die vorhandenen ckStorageGet/ckStorageSet-Helfer (storage-helpers.js).
// ==========================================================================

(function () {
  var AVAILABLE_LANGUAGES = window.CK_AVAILABLE_LANGUAGES || [];
  var CURRENT_LOCALE = window.CK_LOCALE || "de";
  var MANUAL_FLAG = "ck_lang_settled";

  function normalize(code) {
    return (code || "").split("-")[0].toLowerCase();
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Manuelle Auswahl über den Sprachumschalter merken (keine künftige Auto-Umleitung mehr)
    document.querySelectorAll(".lang-switcher__menu a").forEach(function (link) {
      link.addEventListener("click", function () {
        ckStorageSet(MANUAL_FLAG, "1");
      });
    });

    // Automatische Weiterleitung nur, wenn noch keine Sprache "festgelegt" wurde
    if (ckStorageGet(MANUAL_FLAG)) return;
    if (!AVAILABLE_LANGUAGES.length) return;

    var browserLang = normalize(
      (navigator.languages && navigator.languages[0]) || navigator.language || "de"
    );

    if (normalize(CURRENT_LOCALE) === browserLang) {
      ckStorageSet(MANUAL_FLAG, "1");
      return;
    }

    var match = AVAILABLE_LANGUAGES.find(function (lang) {
      return normalize(lang.iso) === browserLang;
    });

    // Sprache als "festgelegt" markieren, BEVOR wir weiterleiten — verhindert
    // eine Umleitungs-Schleife, falls die Weiterleitung selbst fehlschlägt
    ckStorageSet(MANUAL_FLAG, "1");

    if (match) {
      window.location.href = match.root_url;
    }
  });
})();
